import script from "./servicePackageBuyLogList.vue?vue&type=script&lang=ts&setup=true"
export * from "./servicePackageBuyLogList.vue?vue&type=script&lang=ts&setup=true"

import "./servicePackageBuyLogList.vue?vue&type=style&index=0&id=da4cc0ec&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da4cc0ec"]])

export default __exports__